<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree m-r-m m-l-m">
    <mat-tree-node *matTreeNodeDef="let node">
        <button mat-icon-button disabled [attr.id]="buildTreeControlId('btn-leaf-placeholder', node)"></button>
        <img class="icon-layout m-r-s" src="assets/images/bucket-icons/icon-folder.svg" alt="Folder" />
        <div
            class="width text-overflow-ellipsis"
            matTooltipClass="tooltip-style"
            matTooltipPosition="above"
            [attr.id]="buildTreeControlId('lbl-leaf-name', node)"
            appMatTooltip="{{node.Name}}">
            {{node.Name}}
        </div>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"  class="flex-column horizontal-center-align m-l-m">
        <div class="mat-tree-node">
            <button mat-icon-button matTreeNodeToggle [attr.id]="buildTreeControlId('btn-toggle', node)" [attr.aria-label]="'Toggle ' + node.Name">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            <img class="icon-layout m-r-s" src="assets/images/bucket-icons/icon-folder.svg" alt="Folder" />
            <div
                class="width text-overflow-ellipsis"
                matTooltipClass="tooltip-style"
                matTooltipPosition="above"
                [attr.id]="buildTreeControlId('lbl-node-name', node)"
                appMatTooltip="{{node.Name}}">
                {{node.Name}}
            </div>
        </div>
        <div class="m-l-m" [class.disp_none]="!treeControl.isExpanded(node)" role="group">
            <ng-container matTreeNodeOutlet></ng-container>
        </div>
    </mat-nested-tree-node>
</mat-tree>
